import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import { Icon } from "@iconify/react";
import { isDesktop } from "react-device-detect";

import SideBar from "../../components/Sidebar/Sidebar";

import * as actions from "../../store/ducks/delegateDeposit/actions";
import MobileCommissionReport from "./MobileCommissionReport"
import PersonalCommission from "./PersonalCommission";

class CommissionReport extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = 
        {
            pageShow: "personal_commission",
            initialLoading: 
            [
                { id: "personal_commission", loading: true },
                { id: "escrow_wallet", loading: true },
            ],
        };
        this.props.initDelegateDepositInitialLoading(this.state.initialLoading);
    }

    changeTabHandler = (e) => 
    {
        e.preventDefault();
        // console.log(e.target.id)
        this.setState({
            pageShow: e.target.id,
        });
    };

    render() 
    {
        const { t } = this.props;
        const fadeUp = keyframes`
            from {
                opacity: 0;
                transform: translate3d(0, 50px ,0);
            }

            to {
                opacity: 1;
                transform: translate3d(0, 0, 0);
            }
        `;

        return (
            <>
            {isDesktop ? (
                <section className="pf-dashboard">
                    <div className="x-container">
                        <SideBar />
                        <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="pd-card-col h-100">
                                        <div className="pd-header mb-3">
                                            <h4 className="mb-0">{t('sidebar.commission-report')}</h4>
                                        </div>
                                        <div className="pd-content">
                                            <div className="fd-col">
                                                <ul className="nav nav-tabs" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className="nav-link active"
                                                            id="personal_finance"
                                                            data-bs-toggle="tab"
                                                            data-bs-target="#personal-finance"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="personal-finance"
                                                            aria-selected="true"
                                                            onClick={(event) => this.changeTabHandler(event)}
                                                        >
                                                          {t('reports.personal-commission')}
                                                        </button>
                                                    </li>
{/* 
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className="nav-link"
                                                            id="escrow_wallet"
                                                            data-bs-toggle="tab"
                                                            data-bs-target="#escrow-wallet"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="escrow-wallet"
                                                            aria-selected="false"
                                                            onClick={(event) => this.changeTabHandler(event)}
                                                        >
                                                            Delegate Wallet
                                                        </button>
                                                    </li> */}
                                                </ul>
                                            </div>

                                            <div className="tab-content">
                                                {this.state.pageShow === "personal_commission" && <PersonalCommission />}
                                                {/* {this.state.pageShow === "escrow_wallet" && <EscrowWallet />} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </section>
            ) : (
                <MobileCommissionReport
                    {...this.state}
                    {...this.props}
                    changeTabHandler={this.changeTabHandler}
                />
            )}
            </>
        );
    }
}

const mapStateToProps = (state) => 
{
    return {};
};

const mapDispatchToProps = (dispatch) => 
{
    return {
        initDelegateDepositInitialLoading: (data) => dispatch(actions.initDelegateDepositInitialLoading(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(CommissionReport));
